import React, { useRef } from "react";
import { motion, useInView, useViewportScroll, useTransform } from "framer-motion";
import "./HomeWorkProcessSection.css"; 
import processImage from "../../../assets/home/workprocess/workprocess.png"; // Replace with your actual image

const HomeWorkProcessSection = () => {
  const sectionRef = useRef(null);

  // Fade in/out when section scrolls in/out of view
  const isInView = useInView(sectionRef, {
    margin: "-100px 0px -100px 0px",
    once: false,
  });

  // Parallax: subtle upward shift on scroll
  const { scrollY } = useViewportScroll();
  const yOffset = useTransform(scrollY, [0, 300], [0, -40]);

  return (
    <motion.section
      className="wp-section"         // Outer container
      ref={sectionRef}
      style={{ y: yOffset }}
      initial={{ opacity: 0 }}
      animate={{ opacity: isInView ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <div className="wp-content">
        {/* LEFT COLUMN */}
        <div className="wp-left">
          <span className="wp-label">Our Approach</span>
          <h2 className="wp-title">Efficient ASIC Design & Verification Process</h2>
          <p className="wp-subtitle">
            Our streamlined process ensures precise, efficient, and high‐performance ASIC solutions tailored to your specific requirements.
          </p>

          <div className="wp-steps-list">
            <div className="wp-step-item">
              <div className="wp-step-circle">01</div>
              <div className="wp-step-text">
                <h4>Requirement Analysis</h4>
                <p>
                  We meticulously analyze your project's needs, ensuring clarity and precision from the outset.
                </p>
              </div>
            </div>

            <div className="wp-step-item">
              <div className="wp-step-circle">02</div>
              <div className="wp-step-text">
                <h4>Design and Verification</h4>
                <p>
                  Our experts develop and rigorously verify your ASIC designs, guaranteeing performance and reliability.
                </p>
              </div>
            </div>

            <div className="wp-step-item">
              <div className="wp-step-circle">03</div>
              <div className="wp-step-text">
                <h4>Integration & Support</h4>
                <p>
                  We provide seamless integration, comprehensive testing, and ongoing support to optimize your systems continuously.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className="wp-right">
          <div className="wp-experience-box">
            <div className="wp-experience-text">
              <h3>10+</h3>
              <p>Years of Industry Leadership</p>
            </div>
          </div>
          <img src={processImage} alt="Our Process" className="wp-image" />
        </div>
      </div>
    </motion.section>
  );
};

export default HomeWorkProcessSection;